import { es, pt } from 'date-fns/locale';
import PyusdLogo from 'assets/images/pyusd.png';
import UsdcLogo from 'assets/images/usdc.png';

export const VALID_LANGUAGES = ['es', 'en', 'pt'];
export const DEFAULT_LANGUAGE = 'en';
export const LANG_LOCALES = {
  en: 'en-US',
  es: 'es-LA',
  pt: 'pt-BR',
};

export const DATE_FORMAT_LOCALES = {
  en: 'MM/dd/yyyy',
  es: 'dd/MM/yyyy',
  pt: 'dd/MM/yyyy',
};

export const PLACEHOLDER_LOCALES = {
  en: 'mm/dd/yyyy',
  es: 'dd/mm/yyyy',
  pt: 'dd/mm/yyyy',
};

export function getBaseURL() {
  return globalThis.location.origin.replace('app.', '');
}

export function getTosLink(language) {
  const lang = VALID_LANGUAGES.includes(language) ? `/${language}` : '';
  return `https://www.airtm.com${lang}/terms-and-conditions`;
}

export const localeES = es;
localeES.code = LANG_LOCALES.es;

export const localePT = pt;
localePT.code = LANG_LOCALES.pt;

export const LOCALES = {
  es: localeES,
  pt: localePT,
};

export const STATUS = {
  ACCEPTED: 'ACCEPTED',
  CANCEL_REQUESTED: 'CANCEL_REQUESTED',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  CONFIRMED: 'CONFIRMED',
  CREATED: 'CREATED',
  PENDING_CREATION: 'PENDING_CREATION',
  ERROR: 'ERROR',
  FAILED: 'FAILED',
  FAILED_WITH_ERROR: 'FAILED_WITH_ERROR',
  IN_PROGRESS: 'IN_PROGRESS',
  IN_REVIEW: 'IN_REVIEW',
  MEDIATION: 'MEDIATION',
  MEDIATION_SETTLED_MAKER: 'MEDIATION_SETTLED_MAKER',
  MEDIATION_SETTLED_TAKER: 'MEDIATION_SETTLED_TAKER',
  MEDIATION_SETTLED_BUYER: 'MEDIATION_SETTLED_BUYER',
  MEDIATION_SETTLED_SELLER: 'MEDIATION_SETTLED_SELLER',
  PENDING: 'PENDING',
  UPDATE_PENDING: 'UPDATE_PENDING',
  FRAUD_REJECTED: 'FRAUD_REJECTED',
  FRAUD_REVIEW: 'FRAUD_REVIEW',
  FRAUD_APPROVED: 'FRAUD_APPROVED',
  MATCHED: 'MATCHED',
  MERGED: 'MERGED',
  PENDING_TRANSFER: 'PENDING_TRANSFER',
};

export const STATUS_CLOSED = [
  STATUS.CANCELED,
  STATUS.COMPLETED,
  STATUS.ERROR,
  STATUS.FAILED,
  STATUS.MEDIATION_SETTLED_MAKER,
  STATUS.MEDIATION_SETTLED_TAKER,
  STATUS.MEDIATION_SETTLED_BUYER,
  STATUS.MEDIATION_SETTLED_SELLER,
  STATUS.FRAUD_REJECTED,
  STATUS.MERGED,
];

export const STATUS_OPEN = [
  STATUS.ACCEPTED,
  STATUS.CANCEL_REQUESTED,
  STATUS.CONFIRMED,
  STATUS.CREATED,
  STATUS.FRAUD_APPROVED,
  STATUS.FRAUD_REVIEW,
  STATUS.IN_PROGRESS,
  STATUS.IN_REVIEW,
  STATUS.MATCHED,
  STATUS.MEDIATION,
  STATUS.PENDING,
  STATUS.UPDATE_PENDING,
  STATUS.PENDING_TRANSFER,
];
export const STATUS_AVAILABLE_OPERATIONS = [STATUS.CREATED, STATUS.FRAUD_APPROVED];
export const STATUS_CREATED = [
  STATUS.CREATED,
  STATUS.PENDING,
  STATUS.FRAUD_REVIEW,
  STATUS.FRAUD_APPROVED,
];
export const STATUS_CANCELED = [STATUS.CANCELED, STATUS.FRAUD_REJECTED];

export const LOCAL_STORAGE = {
  JWT: 'AirtmJWT',
  JWT_EXPIRES_AT: 'AirtmJWTExpiresAt',
  JWT_IDLE_EXPIRES_AT: 'airtm-jwt-idle-expires-at',
  SHOW_WELCOME_POPUP: 'showWelcomePopup',
  REFERRER_EMAIL: 'AirtmReferrerEmail',
  STORED_NS: 'stored',
  ACTIVITY_FILTERS: 'AirtmActivityFilters',
  PEER_FILTERS: 'AirtmPeerTransfersFilters',
  RESPONSE_TO_TERMS: 'AirtmResponseToTerms',
  LANGUAGE: 'AirtmLng',
  AVATAR: 'Airtm-img-avatar',
  ATTACHMENT: 'Airtm-chat-attachment',
  FORCE_RELOAD: 'AirtmReload',
  KOUNT_WHITELISTED: 'AirtmKountWhitelisted',
  KOUNT_SESSIONID: 'KountSessionid',
  UTM: 'AirtmUTM',
  SKIP_LOGIN_REDIRECTION: 'AirtmSkipLoginRedirection',
  REQUEST_VERIFICATION_EMAIL: 'AirtmVerifyEmailSent',
  TRANSFER_FUNDS_HYDRATOR: 'AirtmTransferFundsHydrator',
  OPT_IN_PROMOTION_ID: 'AirtmOptInPromotionId',
  SHOW_SUCCESSFUL_OPT_IN: 'AirtmShowSuccessfulOptIn',
  PAYONEER_SUCCESSFUL_CONNECTION: 'AirtmPayoneerSuccessfulConnection',
  PAYONEER_UNSUCCESSFUL_CONNECTION: 'AirtmPayoneerUnsuccessfulConnection',
  PAYONEER_SUCCESSFUL_CHALLENGE: 'AirtmPayoneerSuccessfulChallenge',
  MOONPAY_SUCCESSFUL_CREATION: 'AirtmMoonpaySuccessfulCreation',
  MOONPAY_UNSUCCESSFUL_CREATION: 'AirtmMoonpayUnsuccessfulCreation',
  LOGIN_LOOP_LOG: 'AirtmLoginLoopLog',
  ANDROID_REFERRER: 'AirtmAndroidReferrer',
  SKIP_UPDATE_PASSWORD_MODAL: 'AirtmSkipUpdatePasswordModal',
  SKIP_CES_BANNER: 'AirtmSkipCESBanner',
  SKIP_SUBSCRIPTION_MODAL: 'AirtmSkipSubscriptionModal',
  AIRNERS_MARKETING_BANNER: 'AirtmAirnersMarketingBanner',
  YBB_BANNER: 'AirtmYBBBanner',
  YBB_STREAK_PROGRESS_BANNER: 'AirtmYBBStreakProgressBanner',
  YBB_PENDING_PAYMENT_BANNER: 'AirtmYBBPendingPaymentBanner',
};

export const LOCAL_STORAGE_WHITELIST = [
  LOCAL_STORAGE.SKIP_LOGIN_REDIRECTION,
  LOCAL_STORAGE.PEER_FILTERS,
  LOCAL_STORAGE.FORCE_RELOAD,
  LOCAL_STORAGE.KOUNT_SESSIONID,
  LOCAL_STORAGE.SKIP_UPDATE_PASSWORD_MODAL,
  LOCAL_STORAGE.SKIP_CES_BANNER,
  LOCAL_STORAGE.SKIP_SUBSCRIPTION_MODAL,
  `${LOCAL_STORAGE.STORED_NS}.${LOCAL_STORAGE.AIRNERS_MARKETING_BANNER}`,
  `${LOCAL_STORAGE.STORED_NS}.${LOCAL_STORAGE.YBB_BANNER}`,
  `${LOCAL_STORAGE.STORED_NS}.${LOCAL_STORAGE.YBB_STREAK_PROGRESS_BANNER}`,
  `${LOCAL_STORAGE.STORED_NS}.${LOCAL_STORAGE.YBB_PENDING_PAYMENT_BANNER}`,
  '__leanplum_device_id',
  '__leanplum_user_id',
  '__leanplum_session',
  '__leanplum_message_cache',
  '__leanplum_variables',
  '__leanplum_variants',
  '__leanplum_action_metadata',
  '__leanplum_variant_debug_info',
  '__leanplum_token',
];

export const URL_HASHES = {
  SHOW_MFA: '#mfa-code',
  EMAIL_SENT: '#email-sent',
};

export const PAGINATION_PER_PAGE = 25;

export const SUPPORT_EMAIL = 'support@airtm.com';

export const WEBAPP_LINK = 'https://app.airtm.com';

export const PLAYSTORE_LINK = 'https://play.google.com/store/apps/details?id=com.airtm.android';

export const APPSTORE_LINK = 'https://apps.apple.com/app/airtm/id1634470409';

export const CHARGEBACK_RISK_DECLINED_TAG = 'CANCELLATION_REASONS:CHARGEBACK_RISK_DECLINED';

export const TOS_LINK = `${getBaseURL()}/legal/terms-of-service`;

export const LIMIT_REACHED_MODAL_TYPES = {
  IN: 'IN',
  OUT: 'OUT',
};

export const OTP_CODE_LENGTH = 6;

export const CURRENCY = {
  USD: {
    id: 'USD',
    precision: 2,
    symbol: '$',
  },
  USDC: {
    id: 'USDC',
    precision: 2,
    symbol: '$',
  },
};

/**
 * Each time do you set a destination payment method on funds/withdraw page it will pre-fill as default = $100 USDC
 * @type {number}
 */
export const DEFAULT_FUNDS_AMOUNT = 100;

export const DEFUALT_ITEM_BUFFER = 4;
export const USA_BANK_ACCOUNT_MIN_AGE = 14;

export const MAX_AVG_ACCEPTANCE_TIME = 720;

export const MIN_RATE_PRECISION = 4;

export const PRESENTATION_ORDER_HIDDEN_INDEX = 99;

// Anclap Card
export const DEBIT_CARD_PROFITS_ACCOUNT = 'card@airtm.com';

export const DEBIT_CARD_COST_CURRENCY = 'USD';

export const USER_DEBIT_CARD_PAYMENT_TAG = 'anclap-prepaid-ars';

// Subscription Plan
export const AIRTM_SUBSCRIPTION_PLAN_COST = 10;

export const AIRTM_SUBSCRIPTION_ENROLLED_TAG = 'subscribed';

export const AIRTM_SUBSCRIPTION_TRIAL_TAG = 'subscription_trial';

export const AIRTM_PAID_SUBSCRIPTION_TAG = 'paid_subscription';

export const AIRTM_SUBSCRIPTION_RECIPIENT_EMAIL = 'rewards@airtm.com';

export const AIRTM_ME_ACTIVE_TAG = 'airtm-me-active';

export const DEBUG_MODE_ENABLED = !['staging', 'production'].includes(process.env.NODE_ENV ?? '');

export const STABLECOINS = ['airtm:crypto:tether:tether-erc20', 'airtm:crypto:dai'];

export const PYUSD_STABLECOINS = [
  'airtm:crypto:paypal-usd:ethereum',
  'airtm:crypto:paypal-usd:solana',
];

export const USDC_STABLECOINS = [
  'airtm:crypto:usd-coin:stellar',
  'airtm:crypto:usd-coin:ethereum',
  'airtm:crypto:usd-coin:solana',
  'airtm:crypto:usd-coin:avalanche',
  'airtm:crypto:usd-coin:optimism',
];

export const PYUSD_CATEGORY = {
  __typename: 'PaymentMethods__Category',
  id: 'PYUSD',
  translationTag: 'FUNDS:PYUSD',
  image: {
    urls: {
      logo: PyusdLogo,
    },
  },
  helperText: 'FUNDS:BLOCKCHAIN_HELPER_TEXT',
};

export const USDC_CATEGORY = {
  __typename: 'PaymentMethods__Category',
  id: 'USDC',
  translationTag: 'FUNDS:USDC',
  image: {
    urls: {
      logo: UsdcLogo,
    },
  },
  helperText: 'FUNDS:BLOCKCHAIN_HELPER_TEXT',
};

export const VIRTUAL_CARD_PAYMENT_METHOD_CATEGORY = 'airtm:prepaid-card:bridge';

export const DAILY_MAX = 20000;

export const DIRECT_REGEX = /[:-]direct(-withdraw)?$/;
